import { useCallback, useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { type ElementCreator } from 'packages/pages/editor/useElementCreator';
import { isCtrlKey } from '~/helpers/hotKeys';
import { useIsModalOpen } from '~/hooks/useIsModalOpen';

export default function useCreateElementShortcuts(
    elementCreator: ElementCreator,
    showImagePicker: () => void,
    showVideoPicker?: () => void,
    showAudioPicker?: () => void,
) {
    const isModalOpen = useIsModalOpen();

    const handleKeyDown = useCallback(
        (event) => {
            if (isInteractiveElement(event) || isModalOpen) {
                return;
            }

            if (event.shiftKey && isCtrlKey(event)) {
                switch (event.code) {
                    case 'KeyI': {
                        event.preventDefault();
                        showImagePicker();
                        break;
                    }
                    case 'KeyK': {
                        if (!showVideoPicker) {
                            return;
                        }

                        event.preventDefault();
                        showVideoPicker();
                        break;
                    }
                }
            } else if (!event.shiftKey && !isCtrlKey(event)) {
                switch (event.code) {
                    case 'KeyA': {
                        if (!showAudioPicker) {
                            return;
                        }

                        event.preventDefault();
                        showAudioPicker();
                        break;
                    }
                    case 'KeyT': {
                        elementCreator.createTextElement();
                        break;
                    }
                    case 'KeyE': {
                        elementCreator.createEllipseElement();
                        break;
                    }
                    case 'KeyR': {
                        elementCreator.createRectangleElement();
                        break;
                    }
                    case 'KeyI': {
                        event.preventDefault();
                        showImagePicker();
                        break;
                    }
                    case 'KeyV': {
                        if (!showVideoPicker) {
                            return;
                        }

                        event.preventDefault();
                        showVideoPicker();
                        break;
                    }
                }
            }
        },
        [showImagePicker, showVideoPicker, showAudioPicker, elementCreator, isModalOpen],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
}
